//
// TODO: Add other local/session storage keys
//
// LOCAL STORAGE
export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'reelflow/sidebar-collapsed';
export const SIDEBAR_MODE_STORAGE_KEY = 'reelflow/sidebar-mode';
export const PENDING_TEMPLATES_STORAGE_KEY = 'reelflow/pending-templates';
// ...
//
// SESSION STORAGE
export const FLOWS_TABLE_SEARCH_TEXT_STORAGE_KEY =
    'reelflow/flows-table-search-text';
export const PERFORMANCE_TABLE_SEARCH_TEXT_STORAGE_KEY =
    'reelflow/performance-table-search-text';
export const PERFORMANCE_TABLE_SORTING_STORAGE_KEY =
    'reelflow/performance-table-sorting';
export const BUILDER_HISTORY_STORAGE_KEY = 'reelflow/flow-builder-history';
export const BUILDER_HISTORY_ID_STORAGE_KEY =
    'reelflow/flow-builder-history-id';
// ...
//

export const storageKeys = [
    SIDEBAR_COLLAPSED_STORAGE_KEY,
    SIDEBAR_MODE_STORAGE_KEY,
    PENDING_TEMPLATES_STORAGE_KEY,
] as const;

export type StorageKey = (typeof storageKeys)[number];
